<template>
	<div class="about-photo">
		<div class="back" @click="goClick">
			<div class="back-icon"></div>
			相册备份 / 如何使用
		</div>
		<div class="download-wrap">
			<div class="qrcode"></div>
			<div class="dolwnload-text">扫码下载节点小宝app</div>
		</div>
		<div class="download-wrap2">
			<div class="download-text">应用市场搜索“节点小宝”下载</div>
			<div class="download-btn">
				<div class="download-icon"></div>
				AppStore下载
			</div>
			<div class="download-btn download-btn2">
				<div class="download-icon download-icon2"></div>
				应用宝下载
			</div>
			<div class="download-btn download-btn3">
				<div class="download-icon download-icon3"></div>
				.apk安装包下载
			</div>
		</div>
		<div class="how-title-wrap">
			<div class="how-title">如何使用相册备份</div>
		</div>
		<div class="how-content">
			<div class="content-item">
				<div class="item-icon"></div>
				<div class="item-text">
					打开节点 <span>小宝APP-工具箱</span>
				</div>
				<div class="item-icon2"></div>
			</div>
			<div class="content-item content-item2">
				<div class="item-icon"></div>
				<div class="item-text">选中 <span>【相册备份】</span></div>
				<div class="item-icon2"></div>
			</div>
			<div class="content-item content-item3">
				<div class="item-icon"></div>
				<div class="item-text">
					点击 <span>【一键备份】</span>，轻松导出照片
				</div>
				<div class="item-icon2"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "OperatePhoto",
	data: function () {
		return {};
	},
	methods: {
		goClick: function () {
			this.$router.back(-1);
		},
	},
};
</script>

<style lang="less" scoped>
.about-photo {
	padding-top: 10px;
	margin: 0 auto;
	margin-top: 10px;
	width: 940px;
	height: 524px;
	box-sizing: border-box;
	border-radius: 4px;
	background-image: url("../assets/tool/imagebackup-bg.png");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-color: #ffffff;
	border: 1px solid #dddddd;
	border-radius: 4px;
	text-align: center;

	.back {
		// padding-left: 26px;
		width: 200px;
		line-height: 48px;
		font-size: 14px;
		color: #666666;
		cursor: pointer;

		.back-icon {
			display: inline-block;
			margin-top: 15px;
			margin-right: 8px;
			vertical-align: top;
			width: 16px;
			height: 16px;
			background-image: url("../assets/device/infoBack.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
	}
	.download-wrap {
		display: inline-block;
		margin-top: 13px;
		padding-top: 1px;
		vertical-align: top;
		width: 148px;
		height: 174px;
		background-color: #fafbfc;
		box-shadow: 0px 2px 8px rgba(93, 97, 114, 0.5);
		border-radius: 4px;
		box-sizing: border-box;
		.qrcode {
			margin: 0 auto;
			margin-top: 7px;
			display: block;
			width: 134px;
			height: 134px;
			background-image: url("../assets/tool/tool15.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		.dolwnload-text {
			margin-top: 7px;
			font-size: 14px;
			line-height: 20px;
			color: #666666;
			text-align: center;
		}
	}
	.download-wrap2 {
		display: inline-block;
		margin-top: 18px;
		vertical-align: top;
		margin-left: 28px;
		.download-text {
			font-weight: 600;
			font-size: 14px;
			line-height: 20px;
			color: #1a1a1a;
		}
		.download-btn {
			margin-top: 14px;
			width: 148px;
			height: 32px;
			line-height: 32px;
			background-color: #123874;
			box-shadow: 0px 2px 4px rgba(73, 81, 90, 0.2);
			border-radius: 48px;
			color: #ffffff;
			font-weight: 600;
			font-size: 14px;
			text-align: left;
			box-sizing: border-box;
			.download-icon {
				display: inline-block;
				margin-left: 16px;
				margin-right: 4px;
				margin-top: 5px;
				vertical-align: top;
				width: 20px;
				height: 20px;
				background-image: url("../assets/tool/tool16.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
			.download-icon2 {
				background-image: url("../assets/tool/tool17.svg");
			}
			.download-icon3 {
				margin-right: 0px;
				background-image: url("../assets/tool/tool18.svg");
			}
		}
		.download-btn2 {
			margin-top: 18px;
		}
		.download-btn3 {
			margin-top: 18px;
			color: #123874;
			background: rgba(18, 56, 116, 0.1);
			border: 1px solid rgba(18, 56, 116, 0.5);
		}
	}
	.how-title-wrap {
		margin-top: 24px;
		text-align: center;
		.how-title {
			position: relative;
			display: inline-block;
			vertical-align: top;
			font-size: 14px;
			line-height: 20px;
			color: #123874;
		}
		.how-title::before {
			position: absolute;
			content: "";
			left: -372px;
			top: 9px;
			width: 334px;
			height: 1px;
			background-color: rgba(18, 56, 116, 0.3);
		}
		.how-title::after {
			position: absolute;
			content: "";
			right: -372px;
			top: 9px;
			width: 334px;
			height: 1px;
			background-color: rgba(18, 56, 116, 0.3);
		}
	}
	.how-content {
		margin-top: 18px;
		.content-item {
			display: inline-block;
			width: 250px;
			vertical-align: top;
			.item-icon {
				display: inline-block;
				margin-right: 8px;
				margin-top: -6px;
				vertical-align: top;
				width: 22px;
				height: 22px;
				background-image: url("../assets/tool/tool19.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
			.item-text {
				display: inline-block;
				vertical-align: top;
				ont-size: 14px;
				line-height: 20px;
				color: #1a1a1a;
				span {
					font-weight: 600;
				}
			}
			.item-icon2 {
				margin: 0 auto;
				margin-top: 22px;
				width: 151px;
				height: 122px;
				background-image: url("../assets/tool/tool20.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
		}
		.content-item2 {
			.item-icon {
				background-image: url("../assets/tool/tool21.svg");
			}
			.item-icon2 {
				width: 200px;
				height: 122px;
				background-image: url("../assets/tool/tool22.png");
			}
		}
		.content-item3 {
			width: 280px;
			.item-icon {
				background-image: url("../assets/tool/tool23.svg");
			}
			.item-icon2 {
				width: 157px;
				height: 130px;
				background-image: url("../assets/tool/tool24.png");
			}
		}
	}
}
</style>